import { CollectionState } from './reducer';
import { RootState } from '../../../store';
import {
  getCollectionTargeting,
  toSlotTargeting,
} from '../../../lib/adTargeting';
import adSizes from '../adSizes';
import { Ads } from '../../../components/presentational/Ad';

interface State extends RootState {
  collection: CollectionState;
}

export type Collection = State['collection'];
export type Brand = State['collection']['brand'];
export type AdConfig = State['collection']['adConfig'];
export type Articles = State['collection']['articles'];
export type Holidays = State['collection']['holidays'];
export type Hero = State['collection']['hero'];

export const collectionSelector = ({ collection }: State): Collection =>
  collection;

export const moreArticlesURLSelector = ({
  collection: { moreArticlesURL = '' },
}: State): string => moreArticlesURL;

export const popularArticlesURLSelector = ({
  collection: { popularArticlesURL = '' },
}: State): string => popularArticlesURL;

export const adsSelector = ({ collection }: State): Ads => {
  const { hideAds, adConfig } = collection;

  if (hideAds) return {};

  const targeting = toSlotTargeting(getCollectionTargeting(collection));

  return Object.keys(adConfig.units).reduce(
    (acc, slot) => ({
      ...acc,
      [slot]: {
        ...adSizes[slot],
        adUnitPath: adConfig.units[slot],
        targeting,
      },
    }),
    {}
  );
};
